import {useEffect,useState} from 'react';
import SearchBar from "material-ui-search-bar";
import { useHistory } from "react-router-dom";
import {Grid, Typography,Card,CardActions,CardContent,Button,IconButton,Tooltip,InputAdornment,InputLabel,Input,TextField} from '@material-ui/core';
import {makeStyles,withStyles } from '@material-ui/core/styles';
import LinkIcon from '@material-ui/icons/Link';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import SearchIcon from '@material-ui/icons/Search';
import { Skeleton } from '@material-ui/lab';
import {loadSkeleton,DASHBOARD_TEXTS,api} from '../utility';
import {DebounceInput} from 'react-debounce-input';
import _ from 'lodash';
import store from 'store';
import {useDispatch} from 'react-redux';
import * as briefActions from '../actions/briefActions';

TimeAgo.addDefaultLocale(en);

const useStylesBootstrap = makeStyles((theme) => ({
    arrow: {
      color: theme.palette.common.white,
    },
    tooltip: {
      backgroundColor: theme.palette.primary.main,
    },
  }));

  const MyTextField = withStyles({
    root: {
        "& .MuiInputBase-input": {
            background:'none',
            border: 'none',
            width:'12rem',
            fontSize: '14px'
        },
        "& .MuiInputBase-input:focus": {
            boxShadow:'none',
            outline:'none'
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before" : {
            borderBottom:'unset'
        },
        "& .MuiInput-underline:before": {
            borderBottom:'unset'
        },
        "& .MuiInput-underline:after": {
            borderBottom:'unset'
        }
    }
    })(DebounceInput);
  

function DashboardContentLegacy(props){
    const tooltipClass = useStylesBootstrap();
    const timeAgo = new TimeAgo('en-US')
    const [searchString, setSearchString] = useState("");
    const history = useHistory();
    const dispatch = useDispatch();
    
    const briefView = (id) => {
        history.push(`/brief/${id}`);
    }

    useEffect(()=>{
        if(searchString.length > 1){
            if(props.Briefs){
                const searchURL = `${api.GET_BASE_URL('TOPIC_BASE_URL')}keyword_reports?filters=filter%5Buser_id%5D=all&filter%5Bsearch%5D=${searchString}`;
                fetch(searchURL, {
                "headers": {
                    "accept": "*/*",
                    "accept-language": "en-GB,en-US;q=0.9,en;q=0.8",
                    "content-type": "application/json",
                    "authorization": `Bearer ${store.get('topicToken')}`
                },
                "method": "GET"
                })
                .then((res) => res.json())
                .then(res => {
                    dispatch(briefActions.getBriefsSucess(res));
                });
            }
        }else{
            dispatch(briefActions.getBriefs());
        }
    }, [searchString])

    return (
        <Grid container xs="12" md="12" direction="row" spacing={1}>
            <Grid xs="12" item style={{padding:'0.5rem 1.5rem'}}>
                <Typography variant="h6" color="primary" style={{fontWeight:"bold"}}>{DASHBOARD_TEXTS.SEARCH_BRIEF_TEXT_HEADING}</Typography>
                </Grid>
                <Grid xs="12" item style={{textAlign:'center',padding:'0.3rem 1.8rem'}}>
                    <Card style={{padding:'0.3rem 2rem', paddingLeft: '14px',borderRadius:'30rem'}}>
                        <Grid container display="flex">
                            <Grid item>
                                <SearchIcon color="primary" size="small" style={{position: 'relative', top: '3px', opacity: '0.6'}} />
                            </Grid>
                            <Grid item style={{flexGrow: '1'}}>
                                <MyTextField
                                    fullWidth
                                    minLength={2}
                                    debounceTimeout={300}
                                    onChange={(e)=>{setSearchString(e.target.value)}}
                                    style={{all: 'initial',marginBottom: '0.4rem', height: '100%', width: '100%', fontFamily: 'inherit'}}
                                    placeholder={DASHBOARD_TEXTS.BRIEF_SEARCH_PLACEHOLDER_TEXT}
                                    type="text"
                                    value={searchString}
                                />
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                <Grid xs="12" item style={{padding:'0.5rem 1.5rem', marginTop: '21px'}}>
                    <Typography variant="h6" color="primary" gutterBottom  style={{fontWeight:"bold"}}>{DASHBOARD_TEXTS.BRIEF_SUB_HEADING_TEXT}</Typography>
                    <Grid container xs="12" direction="row">
                        <Grid item xs="9">
                            <Typography variant="body1" color="primary" style={{paddingLeft: '13px', fontSize: '14px'}}>
                                Keyword
                            </Typography>
                        </Grid>
                        <Grid item xs="3">
                            <Typography variant="body1" color="primary" style={{paddingRight: '13px', fontSize: '14px'}} >
                                Created
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs="12" item style={{padding:'0.5rem 1.5rem'}}>
                    {(props.Briefs && props.Briefs.briefs && !_.isEmpty(props.Briefs.briefs.reports))?
                        props.Briefs.briefs.reports.map((singleBrief) => (
                                <Card style={{marginBottom:10,borderRadius:'0.3rem',cursor:'pointer'}} onClick={()=>briefView(singleBrief.id)} >
                                    <CardContent style={{paddingBottom: '13px', padding: '13px'}}>
                                        <Grid container xs="12" direction="row">
                                            <Grid item xs="9">
                                                <Typography variant="body1" color="primary" style={{fontSize: '14px'}}>
                                                {singleBrief.name}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs="3">
                                                <Typography variant="caption" color="primary" style={{color:'grey'}}>
                                                    {timeAgo.format(new Date(singleBrief.created_at),'round')}
                                                </Typography>
                                            </Grid>
                                    </Grid>
                                    </CardContent>
                                </Card>
                        ))
                        : 
                        loadSkeleton('card')
                    }
                </Grid>
        </Grid>
    );
}

export default DashboardContentLegacy;